import { Component } from '@angular/core';
import { DocumentsEnum } from '@app/core/enums/documents.enum';

/** @deprecated - this is moved to libs/shared/feature-coverage-modals */
@Component({
    selector: 'ins-glas-info',
    templateUrl: './glas-info.component.html',
})
export class GlasInfoComponent {
    public documentsEnum = DocumentsEnum;
}
